export default __webpack_public_path__ + "static/media/province-of-ontario-logo.9874c413.jpg";